<!--
    课程分享-课程批量授权-授权账号弹窗
    作用：第三步中的授权账号弹窗，授权账号
    说明：版本3.0
-->
<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    title="授权账号"
    width="1000px">
    <div class="account-dialog">
      <div class="top-info">
        <div class="left">
          <span class="item">校区名称：{{ row.search_clients_name }}</span>
          <span class="item">校区代码：{{ row.search_clients_code }}</span>
        </div>
        <div class="right">备注：被授权的校区账号拥有课程使用权限时间为一年，从授权完成时间起算）</div>
      </div>
      <div class="top-filter">
        <el-input
          v-model="accountName"
          clearable
          class="filter-item"
          placeholder="用户名称"
          size="medium"
          style="width:200px"
          @input="accountName = accountName.trim()"/>
        <el-input
          v-model="accountPhone"
          clearable
          class="filter-item"
          placeholder="用户手机号"
          size="medium"
          style="width:200px"
          @input="accountPhone = accountPhone.trim()"/>
        <el-button
          class="filter-item"
          type="primary"
          size="medium"
          @click="addAccount">+添 加</el-button>
        <el-input
          v-model="inputVal"
          class="filter-item"
          clearable
          placeholder="请输入内容"
          style="width:450px;margin-left:10px"
          size="medium">
          <el-select
            slot="prepend"
            v-model="inputSel"
            placeholder="请选择"
            style="width:120px">
            <el-option
              v-for="(item, index) in inputOption"
              :key="index"
              :label="item.label"
              :value="item.value"/>
          </el-select>
          <el-button
            slot="append"
            @click="handlerSearch">搜索</el-button>
        </el-input>
      </div>
      <el-table
        v-loading="isLoading"
        ref="multipleTable"
        :data="isList"
        row-key="search_staff_mobile"
        fit
        highlight-current-row
        style="width: 100%;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          :reserve-selection="true"
          type="selection"
          width="55"
          align="center"
        />
        <el-table-column
          v-for="(item,index) in tableHead"
          :key="index"
          :label="item.label"
          :prop="item.prop"
          :width="item.width"
        />
      </el-table>
      <!-- 分页 -->
      <el-pagination
        v-if="total"
        :current-page.sync="listQuery.page"
        :page-size="parseInt(listQuery.per_page)"
        :total="total"
        background
        layout="prev, pager, next"
        style="  text-align: right;margin-top: 20px;"
        @current-change="getList()"
      />
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="submitData">确 定</el-button>
      </span>
    </div>
  </el-dialog>
</template>
<script>
import { fetchAuthTeacher, createAuthTeacher } from '@/api/courseOn';

export default {
  name: 'AccountDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    row: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      accountName: null,
      accountPhone: null,
      total: 0,
      listQuery: { // 列表请求参数
        page: 1,
        per_page: 10,
      },
      isDisabled: true,
      isLoading: false,
      tableHead: [{
        prop: 'search_staff_name',
        label: '用户名称',
      }, {
        prop: 'search_staff_mobile',
        label: '用户手机号',
      }],
      isList: [],
      inputVal: '',
      inputSel: 'like[search_staff_name]',
      inputOption: [
        {
          label: '用户名称',
          value: 'like[search_staff_name]',
        },
        {
          label: '用户手机号',
          value: 'like[search_staff_mobile]',
        },
      ],
      selectionVal: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClose() {
      this.$emit('close-dialog');
    },
    getList() {
      this.isLoading = true;
      this.listQuery['equal[search_clients_id]'] = this.row.search_clients_id;
      fetchAuthTeacher(this.$store.state.choicesSchool.id, this.listQuery).then((res) => {
        this.isLoading = false;
        this.isList = res.items;
        this.total = res.meta.total;
        this.$nextTick(() => {
          this.toggleSelection(res.items);
        });
      });
    },
    toggleSelection(rows) {
      const filter = this.$store.state.accountAuth.filter(item => item.id === this.row.search_clients_id);
      const newArr = [];
      if (filter.length) {
        rows.forEach((item) => {
          const isRow = filter[0].staff_id_list.some(v => v.search_staff_id === item.search_staff_id);
          if (isRow) {
            newArr.push(item);
          }
        });
      }
      if (newArr) {
        newArr.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handlerSearch() {
      this.listQuery = {
        page: 1,
        per_page: 10,
      };
      this.listQuery[this.inputSel] = this.inputVal;
      this.getList();
    },
    // 添加账号
    addAccount() {
      if (this.accountPhone) {
        const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (!reg.test(this.accountPhone)) {
          this.$message.warning('请输入正确的手机号！');
          return;
        }
        let obj = {
          clients_code: this.row.search_clients_code,
          mobile: this.accountPhone,
        };
        if (this.accountName) {
          obj = {
            name: this.accountName,
            ...obj,
          };
        }
        createAuthTeacher(this.$store.state.choicesSchool.id, obj).then((res) => {
          if (res.status_code === 200) {
            const judgeArr = res.data.some(item => item.search_clients_code === this.row.search_clients_code);
            if (judgeArr) {
              this.$message.success('账号添加成功！');
              this.getList();
            } else {
              this.$message.warning('无效账号！');
            }
          } else {
            this.$message.warning(res.message);
          }
        });
      } else {
        this.$message.warning('手机号不能为空！');
      }
    },
    // 表格选中项
    handleSelectionChange(val) {
      this.selectionVal = val;
    },
    submitData() {
      const newAccount = [];
      this.selectionVal.forEach((item) => {
        const obj = {
          ...item,
          search_clients_name: this.row.search_clients_name,
        };
        newAccount.push(obj);
      });
      const obj = {
        id: this.row.search_clients_id,
        staff_id_list: newAccount,
      };
      const accountAuth = this.$store.state.accountAuth;
      accountAuth.forEach((item, index) => {
        if (item.id === this.row.search_clients_id) {
          accountAuth.splice(index, 1);
        }
      });
      if (newAccount.length) {
        accountAuth.push(obj);
      }
      this.$store.dispatch('setAccountAuth', accountAuth);
      this.$emit('close-dialog');
      this.$emit('change-data');
      console.log('setAccountAuth', this.$store.state.accountAuth);
    },
  },
};
</script>
<style lang="scss" scoped>
.account-dialog{
  /deep/ .container-table{
    width: 100%;
    max-height: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
  .input-select{
    width: 200px;
  }
}
.top-info{
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  .left{
    .item{
      display: inline-block;
      min-width: 200px;
      margin-right: 10px;
    }
  }
  .right{
    color: #909399;
  }
}
.top-filter{
  margin-bottom: 15px;
  display: flex;
  .filter-item{
    margin-right: 10px;
  }
}
.dialog-footer{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/volumeAuth/components/accountDialog.vue